import { render, staticRenderFns } from "./LastUpdatedModal.vue?vue&type=template&id=2021466b"
import script from "./LastUpdatedModal.vue?vue&type=script&lang=js"
export * from "./LastUpdatedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports